import React from 'react';

import './AssigneMentionLink.scss';
import { WpTooltip, WpTooltipContent, WpTooltipTrigger } from 'Wpds/components/tooltip';

type Props = {
  mentionProps: {
    mention: {
      mentionFullInfo: string;
    };
    children: React.ReactNode;
  };
};

function AssigneMentionLink({ mentionProps }: Props) {
  return (
    <WpTooltip>
      <WpTooltipTrigger>
        <span className="AssigneMentionLink">{mentionProps.children}</span>
      </WpTooltipTrigger>

      {mentionProps.mention?.mentionFullInfo && (
        <WpTooltipContent>{mentionProps.mention.mentionFullInfo}</WpTooltipContent>
      )}
    </WpTooltip>
  );
}

export default AssigneMentionLink;
